import React from "react";
import Contact from "./Contact";

import contact from "../assets/json/contact.json"

const contactConfig = [
  {
    iconSize: "l",
    iconClass: "fab fa-2x fa-linkedin",
    value: contact.linkedin.value,
    label: contact.linkedin.label,
  },
  // {
  //   iconSize: "l",
  //   iconClass: "fab fa-2x fa-facebook",
  //   value: contact.facebook.value,
  //   label: contact.facebook.label,
  // },
  // {
  //   iconSize: "l",
  //   iconClass: "fab fa-2x fa-instagram",
  //   value: contact.instagram.value,
  //   label: contact.instagram.label,
  // },
  {
    iconSize: "l",
    iconClass: "fab fa-2x fa-github-square",
    value: contact.github.value,
    label: contact.github.label,
  },
  {
    iconSize: "l",
    iconClass: "fa fa-lg fa-envelope",
    value: `mailto:${contact.email.value}`,
    label: contact.email.label,
  },
]

const Footer = () => {
  return (
    <div className="footer-content">
      <div className="columns">
        <div className="column is-8 is-offset-2">
          <div className="head has-text-centered">
            <h1 className="title is-3">Contact</h1>
            <hr />
          </div>
          <div className="contact-group">
            {
              contactConfig.map((v,k) => (
                <p key={k}>
                  <Contact
                    iconSize={v.iconSize}
                    iconClass={v.iconClass}
                    link={v.value}
                    label={v.label}
                  />
                </p>
              ))
            }
          </div>
        </div>
      </div>
      <span className="help cr has-text-centered">
        All right reserved by <strong>Hanif Hayihama</strong>
      </span>
    </div>
  )
}

export default Footer;
